import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

export const DEFAULT_OFFER_LIST_URL = '/madde-teklifleri/tum-maddeler';

/**
 * Madde üzerindeki bir karar akışı bitince gidilecek liste adresi.
 *
 * Kullanıcı bu maddeye bir teklif listesinden geldiyse o listenin tam adresi döner (rota, filtreler, arama, sayfa,
 * sıralama); adres listedeki satıra tıklanınca saklanır. Saklanan adres yalnız aynı madde için geçerlidir: madde
 * listeden gelinmeden açıldıysa ya da sayfa yenilendiyse `fallback` döner.
 *
 * Güncel madde rotadan okunur: madde detayında `:id`, karar ekranlarında `:offerID`.
 */
export const useOfferListReturnURL = (fallback = DEFAULT_OFFER_LIST_URL) => {
  const { id, offerID: routeOfferID } = useParams();
  const offerID = useSelector(({ common }) => common.offerID);
  const offerListURL = useSelector(({ common }) => common.offerListURL);

  const currentOfferID = routeOfferID ?? id;
  const cameFromList = Boolean(offerListURL) && currentOfferID !== undefined && String(offerID) === String(currentOfferID);

  return cameFromList ? offerListURL : fallback;
};
